/**
 * Generated by orval v7.9.0 🍺
 * Do not edit manually.
 * StavertonAPI
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import {
  useCallback
} from 'react';

import type {
  DeleteUserDeviceParams,
  UserDeviceCreateRequest,
  UserDeviceCreateResponse,
  UserDeviceDeleteResponse,
  UserDeviceListResponse,
  UserDeviceUpdateRequest,
  UserDeviceUpdateResponse
} from './index.schemas';

import { useCustomInstance } from '../staverton.openapi.axios';





export const useListUserDevicesHook = () => {
        const listUserDevices = useCustomInstance<UserDeviceListResponse>();

        return useCallback((
    
 signal?: AbortSignal
) => {
        return listUserDevices(
          {url: `/UserDevice/List`, method: 'GET', signal
    },
          );
        }, [listUserDevices])
      }
    

export const getListUserDevicesQueryKey = () => {
    return [`/UserDevice/List`] as const;
    }

    
export const useListUserDevicesQueryOptions = <TData = Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListUserDevicesQueryKey();

  const listUserDevices =  useListUserDevicesHook();

    const queryFn: QueryFunction<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>> = ({ signal }) => listUserDevices(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListUserDevicesQueryResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>>
export type ListUserDevicesQueryError = unknown


export function useListUserDevices<TData = Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserDevices<TData = Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>,
          TError,
          Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListUserDevices<TData = Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useListUserDevices<TData = Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<ReturnType<typeof useListUserDevicesHook>>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = useListUserDevicesQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const useCreateUserDeviceHook = () => {
        const createUserDevice = useCustomInstance<UserDeviceCreateResponse>();

        return useCallback((
    userDeviceCreateRequest: UserDeviceCreateRequest,
 signal?: AbortSignal
) => {
        return createUserDevice(
          {url: `/UserDevice/Create`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: userDeviceCreateRequest, signal
    },
          );
        }, [createUserDevice])
      }
    


export const useCreateUserDeviceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserDeviceHook>>>, TError,{data: UserDeviceCreateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserDeviceHook>>>, TError,{data: UserDeviceCreateRequest}, TContext> => {

const mutationKey = ['createUserDevice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const createUserDevice =  useCreateUserDeviceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useCreateUserDeviceHook>>>, {data: UserDeviceCreateRequest}> = (props) => {
          const {data} = props ?? {};

          return  createUserDevice(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserDeviceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useCreateUserDeviceHook>>>>
    export type CreateUserDeviceMutationBody = UserDeviceCreateRequest
    export type CreateUserDeviceMutationError = unknown

    export const useCreateUserDevice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useCreateUserDeviceHook>>>, TError,{data: UserDeviceCreateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useCreateUserDeviceHook>>>,
        TError,
        {data: UserDeviceCreateRequest},
        TContext
      > => {

      const mutationOptions = useCreateUserDeviceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useUpdateUserDeviceHook = () => {
        const updateUserDevice = useCustomInstance<UserDeviceUpdateResponse>();

        return useCallback((
    userDeviceUpdateRequest: UserDeviceUpdateRequest,
 ) => {
        return updateUserDevice(
          {url: `/UserDevice/Update`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: userDeviceUpdateRequest
    },
          );
        }, [updateUserDevice])
      }
    


export const useUpdateUserDeviceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserDeviceHook>>>, TError,{data: UserDeviceUpdateRequest}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserDeviceHook>>>, TError,{data: UserDeviceUpdateRequest}, TContext> => {

const mutationKey = ['updateUserDevice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const updateUserDevice =  useUpdateUserDeviceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useUpdateUserDeviceHook>>>, {data: UserDeviceUpdateRequest}> = (props) => {
          const {data} = props ?? {};

          return  updateUserDevice(data,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateUserDeviceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useUpdateUserDeviceHook>>>>
    export type UpdateUserDeviceMutationBody = UserDeviceUpdateRequest
    export type UpdateUserDeviceMutationError = unknown

    export const useUpdateUserDevice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useUpdateUserDeviceHook>>>, TError,{data: UserDeviceUpdateRequest}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useUpdateUserDeviceHook>>>,
        TError,
        {data: UserDeviceUpdateRequest},
        TContext
      > => {

      const mutationOptions = useUpdateUserDeviceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const useDeleteUserDeviceHook = () => {
        const deleteUserDevice = useCustomInstance<UserDeviceDeleteResponse>();

        return useCallback((
    params?: DeleteUserDeviceParams,
 ) => {
        return deleteUserDevice(
          {url: `/UserDevice/Delete`, method: 'DELETE',
        params
    },
          );
        }, [deleteUserDevice])
      }
    


export const useDeleteUserDeviceMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserDeviceHook>>>, TError,{params?: DeleteUserDeviceParams}, TContext>, }
): UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserDeviceHook>>>, TError,{params?: DeleteUserDeviceParams}, TContext> => {

const mutationKey = ['deleteUserDevice'];
const {mutation: mutationOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }};

      const deleteUserDevice =  useDeleteUserDeviceHook()


      const mutationFn: MutationFunction<Awaited<ReturnType<ReturnType<typeof useDeleteUserDeviceHook>>>, {params?: DeleteUserDeviceParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteUserDevice(params,)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserDeviceMutationResult = NonNullable<Awaited<ReturnType<ReturnType<typeof useDeleteUserDeviceHook>>>>
    
    export type DeleteUserDeviceMutationError = unknown

    export const useDeleteUserDevice = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<ReturnType<typeof useDeleteUserDeviceHook>>>, TError,{params?: DeleteUserDeviceParams}, TContext>, }
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<ReturnType<typeof useDeleteUserDeviceHook>>>,
        TError,
        {params?: DeleteUserDeviceParams},
        TContext
      > => {

      const mutationOptions = useDeleteUserDeviceMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    